async function useEvent(action, category, label, value) {
  window.dataLayer.push('event', action, {
    event: action,
    event_category: category,
    event_label: label,
    value: value
  })
}

export { useEvent }
